import React, { Component } from 'react';
export default class Footer extends Component {
  render() {
    return (
      <React.Fragment>
       <footer>
        <div className="row">
          <div className="twelve columns">
            <ul className="social-links">
              <li><a href="https://www.linkedin.com/in/rishav-kumar-7162b44b"><i className="fa fa-linkedin" /></a></li>
              <li><a href="https://github.com/rishav-csenitjsr"><i className="fa fa-github" /></a></li>
              <li><a href="https://www.instagram.com/rishu_kiddy_boy/"><i className="fa fa-instagram" /></a></li>
              <li><a href="https://www.facebook.com/rishav.kumar11"><i className="fa fa-facebook" /></a></li>
              <li><a href="https://twitter.com/RishavK02874063"><i className="fa fa-twitter" /></a></li>
            </ul>
            <ul className="copyright">
              <li>© Copyright 2021</li>
              <li>Design by <a title="Styleshout" href="https://www.linkedin.com/in/rishav-kumar-7162b44b">Rishav Kumar</a></li>   
            </ul>
          </div>
          <div id="go-top"><a className="smoothscroll" title="Back to Top" href="#home"><i className="icon-up-open" /></a></div>
        </div>
      </footer>
      </React.Fragment>
    );
  }
}